import React, { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { NAV_LINKS } from "../mock";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setDone(true);
    setEmail("");
    setTimeout(() => setDone(false), 3500);
  };

  return (
    <footer id="about" className="border-t border-[var(--line)]">
      {/* Newsletter CTA */}
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <div className="rounded-[32px] bg-[var(--ink)] px-7 sm:px-14 py-14 sm:py-20 relative overflow-hidden">
          <div className="relative max-w-2xl">
            <span className="text-xs font-bold tracking-eyebrow text-[var(--olive)] uppercase">
              The weekly rankings
            </span>
            <h2 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-[var(--cream)] leading-[1]">
              Rankings, straight to{" "}
              <span className="font-serif-display italic font-medium text-[var(--olive)]">
                your inbox.
              </span>
            </h2>
            <p className="mt-5 text-lg text-[var(--cream)]/70 leading-relaxed">
              Get each new NHSSA Top 20 the moment it publishes—across every
              sport and division, with sources and dates. Join the list.
            </p>

            <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@school.edu"
                className="flex-1 rounded-full bg-[var(--cream)] px-6 py-4 text-[15px] font-medium text-[var(--ink)] placeholder:text-[var(--muted)] outline-none focus:ring-2 focus:ring-[var(--olive)]"
              />
              <button
                type="submit"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-[var(--olive)] px-7 py-4 text-[15px] font-bold text-white transition-all hover:bg-[var(--olive-2)]"
              >
                {done ? (
                  <>
                    <Check className="w-4 h-4" /> Subscribed
                  </>
                ) : (
                  <>
                    Subscribe
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 pb-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 pt-10 border-t border-[var(--line)]">
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-11 h-11 rounded-2xl bg-[var(--ink)] text-[var(--olive)] font-serif-display text-2xl font-semibold">
              N
            </span>
            <span className="leading-none">
              <span className="block text-[20px] font-extrabold tracking-tight text-[var(--ink)]">
                NHSSA
              </span>
              <span className="block text-[10px] font-semibold tracking-eyebrow text-[var(--muted)] mt-1">
                NATIONAL HIGH SCHOOL SPORTS ASSN.
              </span>
            </span>
          </div>

          <nav className="flex flex-wrap gap-x-7 gap-y-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-sm font-semibold text-[var(--ink)] transition-colors hover:text-[var(--olive-2)]"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <p className="mt-8 text-[13px] text-[var(--muted)]">
          © {new Date().getFullYear()} National High School Sports Association.
          Soccer, lacrosse and squash rankings follow the United Soccer Coaches,
          USA Lacrosse and US Squash polls; football, basketball and volleyball
          are compiled by the NHSSA committee.
          <span className="font-semibold text-[var(--ink)]"> Every ranking shows
          its source and last-updated date.</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
